import type AudioPlayer from '../audioplayer';
import { audioManager } from '../audio-manager';

let _audioPlayer: AudioPlayer | null = null;

export function initAudioPlayerPlayImplementation(audioPlayer: AudioPlayer) {
  _audioPlayer = audioPlayer;
}

export async function runAudioPlayerPlayImplementation() {
  if (!_audioPlayer) return;
  await _audioPlayer.play();
  if (audioManager?.isPlaying('audioplayer')) {
    await audioManager.waitUntilPlaybackEnded('audioplayer');
  }
}
